export default {
  title: 'Current balance is for reference only.',
  more: 'More',
  modal: {
    title: 'Possible balance adjustment',
    text: 'Current balance is for reference only and may be adjusted due to currency conversion',
  },
  message: 'Account statements may be supplemented due to currency conversion',
};
